<template>
    <div class="ex" v-loading="loading">
        <div v-if="examData" class="ex-head">
            <div> </div>
            <div><h3>{{examData.exam}}</h3></div>
            <div class="ex-head-t">剩余时间：<span>{{timeDwwn}}</span></div>
        </div>
        <div v-if="examData" class="ex-re">
            <span v-if="$route.query.type !== 0">考試時間：{{$route.query.apply_begin_date}} 至 {{$route.query.apply_of_date}}</span>
            <span v-if="examData">共{{examData.question.length}}题 总分{{examData.score}}分</span>
        </div>
        <div v-for="(item,index) in examDataList" :key="index">
            <subject :index="index+1" :data="item">
                <el-divider v-if="examDataList.length!=index+1"></el-divider>
            </subject>
        </div>
        <div v-if="examData" class="ex-submit">
            <el-button type="primary" :loading="saveLoading" @click="saveResult">我要交卷</el-button>
        </div>
    </div>
</template>
<script>
import subject from '@p/components/subject'
import { countDown } from '@/utils'
export default {
    data(){
        return {
            loading:false,
            saveLoading:false,
            timeDwwn:'0天0时0分0秒',
            time:'',
            examData:'',                //考试数据
            examDataList:[],
            start_date:'',              //考试开始时间
        }
    },
    created(){
        this.initData(this.$route.query.id);
    },
    methods:{
        //提交数据
        saveResult(isTimeout){
            let params={
                examination_id:this.$route.query.examination_id,        //考试id
                exam_id:this.$route.query.id,                           //试卷id
                start_date:parseInt(this.start_date),
                answer:[]
            };
            let messageError=[];
            this.examDataList.forEach((item,index) => {
                params['answer'][item.id]='';
                if(item.resultValue === ''  || item.resultValue.length === 0) {       //答题为空;增加限制条件
                    messageError.push(index+1);
                    return;
                };
                if(item.categories!=2){
                    params['answer'][item.id]=item.resultValue
                }else{
                    const str = item.resultValue.sort(function(a,b){return a.localeCompare(b)});
                    // params['answer'][item.id]=str.toString().replace(/,/g,'');
                    params['answer'][item.id] = str
                }
            });
            if(!!messageError.length && isTimeout !== true){
                this.$message({
                    showClose: true,
                    message: `請完成第${messageError.join()}题`,
                    type: 'error'
                });
                return;
            }
            this.saveLoading=true;
            this.$http.examination.save(params).then(v=>{
                if(v.status === 200 && v.data.status_code === 200){
                   this.$message({message:v.data.message,type:'success'});
                   history.go(this.$route.query.go ? this.$route.query.go : -1);
                }
                this.saveLoading=false;
            }).catch(er=>{this.saveLoading=false;})
        },
        //初始数据
        initData(id){
            this.loading=true;
            const params = {
                exam_id:this.$route.query.id,                           //试卷id
                examination_id:this.$route.query.examination_id,        //考试id
            };
            this.$http.examination.show(params).then(v=>{
                if(v.status === 200 && v.data.status_code === 200){
                    this.examData=JSON.parse(JSON.stringify(v.data.data));
                    this.examDataList=JSON.parse(JSON.stringify(v.data.data.questionSort));
                    this.examDataList.map((item)=>item.resultValue='')
                    this.timeoutSubmit();
                } else if (v.status === 200 && v.data.status_code === 401) {
                    this.$alert(v.data.message, {
                        confirmButtonText: '確定',
                        type: 'warning',
                        showClose: false,
                        customClass: 'exam-alert-box',
                        callback: action => {
                            this.$router.go(-1);
                        }
                    });
                }
                this.loading=false;
            }).catch(er=>{
                this.loading=false;
            })
        },
        // 超时提交
        timeoutSubmit() {
            this.start_date=new Date().getTime()/1000;
            const nowTime=new Date().getTime()+(this.$route.query.time*1000*60);
            this.time=setInterval(()=>{
                this.timeDwwn=countDown(nowTime);       //倒计时
                if(this.timeDwwn == '0天0時0分0秒'){
                    this.$message({message:'妳已超時！已自动提交',type:'error'});
                    this.saveResult(true);
                }
            },1000)
        }
    },
    beforeDestroy(){
        clearInterval(this.time);
    },
    components:{
        subject
    }
}
</script>
<style lang="less" scoped>
.ex{
    padding-left: 24px;
    flex: 1;
    min-height: 600px;
    &-head{
        display: flex;
        // justify-content: space-between;
        align-items: center;
        margin-top: 30px;
        >div{
            flex: 1;
        }
        h3{
            font-size:20px;
            font-weight:400;
            color:rgba(51,51,51,1);
            text-align: center;
        }
        &-t{
            font-size:16px;
            color:#333333;
            margin-left: 10px;
            text-align: right;
            >span{
                padding: 0 5px;
                color: #4D8EF6;
            }
        }
    }
    &-re{
        height: 54px;
        line-height: 54px;
        font-size: 14px;
        color:rgba(51,51,51,0.50);
        display: flex;
        justify-content: space-between;
        background:rgba(244,244,249,1);
        padding: 0 18px;
        margin-top: 13px;
        margin-bottom: 20px;
    }
    &-submit{
        display: flex;
        justify-content: flex-end;
        margin-top: 43px;
        margin-bottom: 34px;
        .el-button{
            width:120px;
            background:rgba(77,142,246,1);
            font-size:14px;
        }
    }
}

</style>
<style lang="less">
.exam-alert-box {
    width: 470px;
}
</style>
